// eslint-disable-next-line no-control-regex
export const ValidPhonePattern = /^[0-9 +\-/()#]*$/

export const isValidPhone = (phone: string): boolean => {
  return phone.toLowerCase().search(ValidPhonePattern) !== -1
}
